import React from "react";

import { Menu, Button } from "@mantine/core";
import "./DropDownButton.css";
import {
	IconChevronDown,
	IconSquare,
	IconSquareCheck,
	IconTextWrapColumn,
} from "@tabler/icons-react";

class DropDownCheckboxSelector extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = { isOpen: false };
		this.makeCheckboxesMenu = this.makeCheckboxesMenu.bind(this);
		this.makeNonCheckboxesMenu = this.makeNonCheckboxesMenu.bind(this);
		this.makePrefixCheckboxesMenu =
			this.makePrefixCheckboxesMenu.bind(this);
	}

	makeNonCheckboxesMenu() {
		return this.props.nonCheckboxItems
			.map((item, i) => {
				return (
					<Menu.Item
						onClick={() => {
							item.onSelect();
							this.setState({ isOpen: false });
						}}
						key={"non" + i}
					>
						<IconTextWrapColumn
							size={16}
							style={{ verticalAlign: "sub" }}
						/>{" "}
						{item.text}
					</Menu.Item>
				);
			})
			.concat([<Menu.Divider key="divider" />]);
	}

	makePrefixCheckboxesMenu() {
		if (!this.props.prefixCheckboxItems?.length) return [];
		return this.props.prefixCheckboxItems
			.map((item, i) => (
				<Menu.Item
					onClick={() => !item.disabled && item.onSelect()}
					key={"prefix" + i}
					disabled={item.disabled}
				>
					<div>
						{item.selected ? (
							<IconSquareCheck
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						) : (
							<IconSquare
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						)}{" "}
						{item.text}
					</div>
				</Menu.Item>
			))
			.concat([<Menu.Divider key="prefixDivider" />]);
	}

	makeCheckboxesMenu() {
		return this.props.checkboxItems.map((item, i) => {
			return (
				<Menu.Item
					onClick={() => item.onSelect(item.accessor)}
					key={"checkbox" + i}
				>
					<div>
						{item.selected ? (
							<IconSquareCheck
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						) : (
							<IconSquare
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						)}{" "}
						{item.text}
					</div>
				</Menu.Item>
			);
		});
	}

	render() {
		return (
			<div
				className={
					"DropDownButton RegularDropDown" +
					(this.props.className || "")
				}
			>
				<Menu
					opened={this.state.isOpen}
					onChange={(opened) => this.setState({ isOpen: opened })}
					closeOnItemClick={false}
				>
					<Menu.Target>
						<Button
							variant="default"
							onClick={() =>
								this.setState({ isOpen: !this.state.isOpen })
							}
							leftSection={this.props.iconComponent || null}
							rightSection={<IconChevronDown size={14} />}
						>
							{this.props.title}
						</Button>
					</Menu.Target>
					<Menu.Dropdown
						style={{ maxHeight: "60vh", overflowY: "auto" }}
					>
						{[
							...this.makePrefixCheckboxesMenu(),
							...this.makeNonCheckboxesMenu(),
							...this.makeCheckboxesMenu(),
						]}
					</Menu.Dropdown>
				</Menu>
			</div>
		);
	}
}

export { DropDownCheckboxSelector };
